import axios from '../axios'

export default class BaseClass {
    urlBase

    constructor(urlBase){
        this.urlBase = urlBase
    }
    
    async save(){
        if (this.id ?? this.rowid != null)
        {
            const res = await axios.put(`${this.urlBase}${this.id ?? this.rowid}`, this)
            return res
        }
        else {
            const res = await axios.post(this.urlBase, this)
            return res
        }
    }

    async batch(data){
        const res = await axios.post(`${this.urlBase}batch`, data)
        return res
    }

    async get(id){
        await axios.get(`${this.urlBase}${id}`).then(res => {
            for (const [key, value] of Object.entries(res.data)) {
                this[key] = value
            }
        })
    }

    async list(page = 1, page_size = 50, filtros = {}){
        let busqueda = filtros.busqueda ?? ''
        // Importante: el caracter "#" se interpreta como fragmento en URL y NO se envía al servidor.
        // Ej: search=#1004 -> el backend recibe search="".
        // Por eso siempre debemos codificar el parámetro de búsqueda.
        const encodedSearch = encodeURIComponent(busqueda)
        delete filtros.busqueda
        delete filtros.page
        delete filtros.step
        delete filtros.filter
        if(Object.values(filtros).every(x => x === null || x === '')){
            const res = await axios.get(`${this.urlBase}?page=${page}&size=${page_size}&search=${encodedSearch}`)
            return res
        }
        else {
            const res = await axios.post(`${this.urlBase}q/?page=${page}&size=${page_size}&search=${encodedSearch}`,filtros)
            return res
        }
    } 

    async put(id, data){
        const res = await axios.put(`${this.urlBase}${id}`, data)
        return res
    }

    async delete(){
        const res = await axios.delete(`${this.urlBase}${this.id}`)
        return res
    }

}
